




































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DmqCartItem from '@/components/DmqCartItem.vue';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import CartModule from '@/store/modules/cart-module';
import { currency } from '@/utils/filters';
import { CartRetailerSection } from '@/models/cart';

const cartModule = getModule(CartModule, store);

@Component({
  components: {
    DmqCartItem,
  },
  filters: {
    currency,
  },
})
export default class DmqCartRetailerSection extends Vue {

  private paymentMode: string = 'retailer';
  private deliveryMode: string = 'retailer';

  @Prop()
  private retailerSection!: CartRetailerSection;

  private get deliveryFeesValue() {
    return this.retailerSection.deliveryMode === 'delivery' ?
      currency(this.retailerSection.intendedDeliveryFees, 'CHF') :
      '--.--';
  }

  private mounted() {
    this.paymentMode = this.retailerSection.paymentMode;
    this.deliveryMode = this.retailerSection.deliveryMode;
  }

  @Watch('retailerSection')
  private retailerSectionUpdated() {
    this.paymentMode = this.retailerSection.paymentMode;
    this.deliveryMode = this.retailerSection.deliveryMode;
  }

  private updateRetailerSection() {
    cartModule.updateRetailerSection({
      retailerId: this.retailerSection.retailerId,
      paymentMode: this.paymentMode,
      deliveryMode: this.deliveryMode,
    });
  }

}

